import _ from 'lodash';
import React, { Component, PropTypes } from 'react';

// Import the CSS
import '../../scss/components/_input.scss';

export default class Input extends Component {
	blockClass = 'input';
	element;

	render() {
		let classes = [this.blockClass];

		// Add additional classes based on the props
		if (this.props.style) {
			classes.push(`${this.blockClass}-${this.props.style}`);
		}
		if (this.props.className) {
			classes.push(this.props.className);
		}

		let props = _.omit(this.props, ['className', 'style']);

		return (
			<input
				className={classes.join(' ')}
				type={this.props.type}
				ref={element => (this.element = element)}
				{...props}
			/>
		);
	}
}

Input.propTypes = {
	type: PropTypes.string,
	className: PropTypes.string,
	style: PropTypes.string,
};

Input.defaultProps = {
	type: 'text',
};



// WEBPACK FOOTER //
// ./src/assets/js/components/Input.js